export const formatInitials = (value: string): string => {
  value = value
    .toUpperCase()
    .trim()
    .replace(/[^A-Z]/g, '');

  return `${value.split('').join('. ')}${value.length > 0 ? '.' : ''}`;
};

export const addLeadingZero = (value: string | number): string => {
  return `0${value}`.slice(-2);
};
